import { useCallback, useEffect, useState } from 'react';

// One selected hazard at a time. The selection drops itself when the event disappears from the
// list, when its type is switched off in the layer filters, or when the weather layer is hidden.
export function useHazardSelection({ events, activeEventTypes, enabled }) {
  const [selectedId, setSelectedId] = useState(null);
  const selectedEvent = events.find((e) => e.id === selectedId) ?? null;

  useEffect(() => {
    if (selectedId == null) return;
    const gone = !selectedEvent || !activeEventTypes.includes(selectedEvent.type) || !enabled;
    if (gone) setSelectedId(null);
  }, [selectedId, selectedEvent, activeEventTypes, enabled]);

  const selectEvent = useCallback((e) => setSelectedId(e?.id ?? null), []);
  const clearSelection = useCallback(() => setSelectedId(null), []);
  return { selectedEvent, selectEvent, clearSelection };
}
